module.exports = __webpack_public_path__ + "static/media/pomegranate.e66d3e57.png";